import customAxios from "./axiosConfig";

const InvoiceService = {
  list (params) {
    const api_url = window.Urls['recurrentinvoice-list']();
    return customAxios.get(api_url, { params: params });
  },
  customerList () {
    const api_url = window.Urls['customer-list']();
    return customAxios.get(api_url);
  },
  update (pk, data) {
    // TODO add mixpanel event here?
    const api_url = window.Urls['recurrentinvoice-detail'](pk);
    return customAxios.put(api_url, data)
  },
  create (data) {
    const api_url = window.Urls['recurrentinvoice-list']();
    return customAxios.post(api_url, data)
  },
  retrieve (pk, params) {
    const api_url = window.Urls['recurrentinvoice-detail'](pk);
    return customAxios.get(api_url, { params: params });
  },
}

export default InvoiceService;
